import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker } from './Components/Csa/offline/registerServiceWorker';
import { watchConnection } from './Components/Csa/offline/csaRepo';
if (process.env.NODE_ENV === 'development') {
  const observer = new MutationObserver(() => {
    const errorElements = document.querySelectorAll('[id^="__react-error__"]');
    errorElements.forEach((el) => el.remove());
  });
  observer.observe(document.body, { childList: true });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// Offline capture (design §9). Both are no-ops until an audit has been
// provisioned, and the service worker only registers in a production build.
registerServiceWorker();
watchConnection();

reportWebVitals();
